import { render, staticRenderFns } from "./PushNotificationList.vue?vue&type=template&id=fb060944&"
import script from "./PushNotificationList.vue?vue&type=script&lang=js&"
export * from "./PushNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports